<template>
    <prep-adherence :nextDisabled="nextDisabled">
        <p>
            AND… you also shared that you don’t take PrEP every day. Meaning, there’s a gap between these 3 important points and your actual behavior. Why do you think there’s such a gap for you? (choose all that apply)
        </p>
        <v-checkbox v-for="gap in prepGaps" :key="gap.id" :label="gap.text" :value="gap.id" v-model="selectedGaps" hide-details dense></v-checkbox>
    </prep-adherence>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { filter, map, forEach } from 'lodash';

    export default {
        data: function () {
            return {
                selectedGaps: []
            };
        },
        computed: {
            prepSelectedGaps() {
                let prepSelectedGaps = map(filter(this.prepGaps, 'selected'), 'id');

                if (prepSelectedGaps) {
                    return prepSelectedGaps;
                } else return [];
            },
            prepGaps: sync('prepAdherenceGaps')
        },
        methods: {
            nextDisabled() {
                return this.selectedGaps.length === 0;
            }
        },
        watch: {
            selectedGaps() {
                forEach(this.prepGaps, (o) => {
                    if (this.selectedGaps.includes(o.id)) {
                        o.selected = true;
                    } else {
                        o.selected = false;
                    }
                });
            }
        },
        mounted() {
            this.selectedGaps = this.prepSelectedGaps;
        }
    };
</script>
